import Wrapper from "../../product/global/homepage/Wrapper";
import React, { FormEvent, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Validation,
  ValidationI,
  ValidationTypes,
} from "../../product/global/formFields/legacyFields/Validation/validation";
import PublicWrapper from "../../product/global/homepage/PublicWrapper";
import FeedbackContainer from "../../product/global/homepage/FeedbackContainer";
import { Box, Button, TextField } from "@mui/material";
import { AuthRequest } from "../../product/redux/config/serviceInstances";
import Loader from "../../product/global/loader/Loader";
import {
  TextVariant,
  TypographyNew,
} from "../../product/global/typography/typography";
import styled from "styled-components";
import Topbar from "../topbar/Topbar";

const ButtonC = styled.div`
  margin-top: 4em;
`;
const config = {
  withCredentials: true,
};

export interface EmailComponentProps {
  reset?: boolean;
}

const Email = (props: EmailComponentProps): React.ReactElement => {
  const history = useHistory();
  const validation: ValidationI = { error: false, message: null };
  const [formFields, setFormFields] = useState({
    email: { value: "", validation: validation },
  });

  const [formState, setFormState] = useState({
    loading: false,
    error: false,
    message: "",
  });

  const createAccount = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const validateEmail = Validation(
      ValidationTypes.EMAIL,
      formFields.email.value
    );

    if (!validateEmail.error) {
      setFormState({ loading: true, error: false, message: "" });
      const endpoint = props.reset ? "/users/reset" : "/users/add";
      AuthRequest.post(endpoint, { email: formFields.email.value }, config)
        .then(() => {
          setFormState({ loading: false, error: false, message: "" });
          history.push({
            pathname: "/register/confirmation",
            state: formFields.email.value,
          });
        })
        .catch((error) => {
          const errorMessage =
            error.response?.data?.message ??
            "Der Account konnte nicht erstellt werden.";

          setFormState({
            loading: false,
            error: true,
            message: errorMessage,
          });
        });
    } else {
      setFormFields({
        email: {
          ...formFields.email,
          validation: validateEmail,
        },
      });
    }
  };

  return (
    <PublicWrapper>
      <Topbar />
      <Wrapper
        onSubmit={(e) => {
          createAccount(e);
        }}
      >
        <TextField
          label={"Email"}
          variant={"standard"}
          sx={{ width: "100%" }}
          value={formFields.email.value}
          error={formFields.email.validation.error}
          onChange={(e) =>
            setFormFields({
              email: {
                value: e.target.value,
                validation: { error: false, message: null },
              },
            })
          }
        />
        &#160;
        <ButtonC>
          <Button
            variant={"contained"}
            color={"secondary"}
            onClick={() => history.push("/app/login")}
          >
            Zurück
          </Button>
          &nbsp; &nbsp;
          <Button type={"submit"} variant={"contained"} color={"primary"}>
            Weiter
          </Button>
        </ButtonC>
      </Wrapper>
      {formState.loading ? <Loader /> : <></>}
      <br />
      <FeedbackContainer>
        {formFields.email.validation.error ? (
          <TypographyNew variant={TextVariant.subtitle2} marginTop={"10px"}>
            {formFields.email.validation.message}
          </TypographyNew>
        ) : formState.error ? (
          <>
            <TypographyNew variant={TextVariant.subtitle2} marginTop={"10px"}>
              {formState.message}
            </TypographyNew>
          </>
        ) : (
          <></>
        )}
      </FeedbackContainer>
      <Box
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <TypographyNew
          variant={TextVariant.subtitle2}
          marginBottom={"20px"}
          marginTop={"20px"}
        >
          Hinweis für Mitarbeiter/innen:
        </TypographyNew>
        <TypographyNew variant={TextVariant.caption}>
          Wenn ihre Firma bereits HeavenHR 2.0 nutzt, registrieren Sie sich
          bitte ausschließlich über den per E-Mail versendeten persönlichen
          Einladungs-Link. Bitte kontaktieren Sie dazu Ihre Personalabteilung.
        </TypographyNew>
      </Box>
    </PublicWrapper>
  );
};

export default Email;
